import { Box } from "@chakra-ui/react";
import React from "react";
import { focusStyle } from "../styles/chakraTheme/biblioteksentralenChakraTheme";

interface Props {
  id: string;
  /**
   * angir hvor mye luft til vil ha over HashLinkTarget ved bruk av hash-lenke, eks '4rem'
   */
  spaceAbove?: string;
  /**
   * angir om du vil ha fokusramme rundt komponenten som mounter HashLinkTarget. Da må komponenten du wrapper med ha position: relative | absolute el
   */
  focusOnParent?: boolean;
}

const focusOnRelativeParentStyle = {
  _focusWithin: {
    position: "static",
    boxShadow: "none",
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
      pointerEvents: "none",
      borderRadius: "0.25rem",
      ...focusStyle,
    },
  },
};

/*
 * Komponent som sørger for luft over anchors (elementer man kan lenke til med hash-lenker feks <a href="#min-overskrift">Ta meg til overskrift</a>)
 */
export function HashLinkTargetBS(props: Props) {
  return (
    <Box position="relative" css={props.focusOnParent ? focusOnRelativeParentStyle : undefined}>
      <Box
        id={props.id}
        tabIndex={props.focusOnParent ? -1 : undefined}
        position="absolute"
        top={`-${props.spaceAbove || "2.5rem"}`}
        _focus={{
          boxShadow: "none !important",
        }}
      />
    </Box>
  );
}
